<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">

        <!-- 舊品牌下拉 -->
        <!--<div class="form-group text-left">-->
          <!--<div class="btn btn-default btn-table-title">匯出表單</div>-->
        <!--</div>-->
        <!-- <div class="form-group" v-if="brandBrief.length > 1">
          <select class="form-control h-38" v-model="brandSelect">
            <option :value="0">== 品牌 ==</option>
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select>
        </div> -->

        <!-- 新品牌搜尋下拉 -->
        <div class="form-group" v-if="brandBrief.length > 2 && $route.name !== 'storeInfo'">
          <multiselect
            v-model="brandSelect"
            :options="brandBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="== 品牌 =="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
          />
        </div>

        <!-- 舊門市下拉 -->
        <!-- <div class="form-group" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1 && $route.name !== 'storeInfo'">
          <select class="form-control h-38" v-model="storeSelect">
            <option :value="0">== 門市 ==</option>
            <option v-for="store in storeBrief" :value="store.value">
              {{store.label}}
            </option>
          </select>
        </div> -->

        <!-- 新門市搜尋下拉 -->
        <div class="form-group" v-if="brandSelect.value !== 0 && brandSelect.value !== '0' && storeBrief.length > 2 && $route.name !== 'storeInfo'">
          <multiselect
            v-model="storeSelect"
            :options="storeBrief"
            :searchable="true"
            :allow-empty="false"
            :close-on-select="true"
            placeholder="== 門市 =="
            :show-labels="false"
            :multiple="false"
            label="label"
            track-by="value"
          />
        </div>
        <br>
        <!-- 星級 -->
        <div class="form-group">
          <select class="form-control h-38" v-model="starSelect">
            <option v-for="star in starList" :value="star.value">
              {{star.label}}
            </option>
          </select>
        </div>
        <!-- 回覆 -->
        <div class="form-group">
          <select class="form-control h-38" v-model="repliedSelect">
            <option v-for="replied in repliedList" :value="replied.value">
              {{replied.label}}
            </option>
          </select>
        </div>
        <!-- 最新回覆 -->
        <div class="form-group">
          <select class="form-control h-38" v-model="mainSelect">
            <option v-for="main in mainList" :value="main.value">
              {{main.label}}
            </option>
          </select>
        </div>
        <br>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1">時間</option>
          </select>
        </div>
        <div class="form-group input-group time-box" v-if="searchSelect == 1">
          <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
          <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
          <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
          <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
          <span class="input-group-btn">
            <button class="btn btn-default submit-btn btn-search" type="button"
                    id="search" style="height: 72px" @click="search(1)">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 2">
          <div class="input-group">
            <input class="form-control" type="text" v-model="orderSn">
            <span class="input-group-addon c-pointer" @click="search(2)"><i class="fa fa-search"></i></span>
          </div>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 3">
          <div class="input-group">
            <input class="form-control" type="text" v-model="shopper">
            <span class="input-group-addon c-pointer" @click="search(3)"><i class="fa fa-search"></i></span>
          </div>
        </div>
        <div class="form-group search-bar" v-if="searchSelect == 4">
          <div class="input-group">
            <input class="form-control" type="text" v-model="subOrderAmount">
            <span class="input-group-addon c-pointer" @click="search(4)"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit"></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99">品牌(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="roleType === 99 || roleType === 30">分店(ID)</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">訂單編號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">類型</th>
            <!-- :TODO 將改成手機帳號ID-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂購人</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">實付金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">星級</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">留言<!-- (時間)--></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="ratingList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="ratingList.length > 0">
          <tr class="even" role="row" v-for="(rating, index) in ratingList">
            <td class="sorting_1">{{index + 1}}</td>
            <td v-if="roleType === 99">{{rating.brand_name}} ({{rating.brand_id}})</td>
            <td v-if="roleType === 99 || roleType === 30">{{rating.store_name}}({{rating.store_id}})</td>
            <td>
              <router-link :to="{path: '/orderInfo/' + rating.order_id}" target="_blank">
                {{rating.order_sn}}
              </router-link>
            </td>
            <td>
              <i v-if="rating.delivery_type === 1" class="fa fa-hand-paper-o" aria-hidden="true"></i>
              <i v-if="rating.delivery_type === 2" class="fa fa-inbox" aria-hidden="true"></i>
              <i v-if="rating.delivery_type === 3" class="fa fa-motorcycle" aria-hidden="true"></i>
              <i v-if="rating.delivery_type === 4" class="fa fa-shopping-bag" aria-hidden="true"></i>
              <i v-if="rating.delivery_type === 5" class="fa fa-glass" aria-hidden="true"></i>
              <i v-if="rating.delivery_type === 21" class="fa fa-qrcode" aria-hidden="true"></i>
            </td>
            <td>{{rating.shopper_name}}</td>
            <td>{{rating.total_paid_money}}</td>
            <td :class="rating.star > 3 ? 'text-success' : 'text-danger'"><i class="fa fa-star" aria-hidden="true"></i>&nbsp;{{rating.star}}</td>
            <td>
              {{rating.comment}}<!-- <small>&nbsp;({{rating.create_time}})</small>-->
            </td>
            <td>
              <button class="btn btn-default" :class="{'btn-success': !rating.is_replied}" data-toggle="modal" data-target="#ratingModal" @click="openModal(rating)">
                <span v-if="rating.is_replied">修改</span><span v-else>回覆</span>評價
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
      >
      </paginate>
    </div>
    <div class="modal fade" id="ratingModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title"><span v-if="ratingInfo.is_replied">修改</span><span v-else>回覆</span>評價</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <p :class="ratingInfo.star > 3 ? 'text-success' : 'text-danger'">
                  <i class="fa fa-star" aria-hidden="true"></i>&nbsp;{{ratingInfo.star}}
                </p>
                <p>{{ratingInfo.comment}}</p>
                <p class="text-right"><small>{{ratingInfo.create_time}}</small></p>
                <!-- <hr> -->
                <div class="m-t-10">
                  <textarea class="w-100-p p-10" style="border: 1px solid #ddd;min-height: 250px" v-model="ratingInfo.reply_comment"></textarea>
                </div>
                <p class="text-right"><small>{{ratingInfo.reply_time}}</small></p>
              </div>
            </div>
            <div class="row">
              <!--
              <button type="button" class="btn btn-default" @click="defaultComment(1)">感謝支持</button>
              <button type="button" class="btn btn-default" @click="defaultComment(2)">抱歉</button>
              <button type="button" class="btn btn-default" @click="defaultComment(3)">已聯絡</button>
              -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-success" @click="reply" data-dismiss="modal">確定<span v-if="ratingInfo.is_replied">修改</span><span v-else>回覆</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
export default{
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: '',
      total: 1,
      count: 20,
      ratingList: [],
      ratingInfo: {}, // 被選取的評價
      shopperId: 0,
      shopper: '',
      orderSn: '',
      subOrderAmount: '',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      searchSelect: 1,
      brandSelect: {
        value: 0,
        label: '== 品牌 =='
      },
      storeSelect: {
        value: 0,
        label: '== 門市 =='
      },
      typeSelect: 99,
      repliedSelect: 99, // 回覆狀態
      starSelect: 0, // 星數
      mainSelect: 1,
      isCreatedTime: false,
      // date
      menuTime: {
        start: {
          time: moment().format('YYYY-MM-DD')
        },
        end: {
          time: moment().format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0,
      mainList: [
        {label: '== 所有評價 ==', value: 99},
        {label: '最新評價', value: 1},
        {label: '過去評價', value: 0}
      ],
      starList: [
        {label: '== 星數 ==', value: 0},
        {label: '五星', value: 5},
        {label: '四星', value: 4},
        {label: '三星', value: 3},
        {label: '二星', value: 2},
        {label: '一星', value: 1}
      ],
      repliedList: [
        {label: '== 回覆狀態 ==', value: 99},
        {label: '已回覆', value: 1},
        {label: '未回覆', value: 0}
      ],
      isLoading: true
    }
  },
  methods: {
    defaultComment (type) {
      // 1 感謝支持
      // 2 抱歉
      // 3 已聯絡
      if (type === 1) {
        this.ratingInfo.reply_comment = '感謝您的支持與購買！希望下次能再為您服務喔 ^^'
      } else if (type === 2) {
        this.ratingInfo.reply_comment = '抱歉造成您的困擾，我們會再多注意細節的！謝謝您的體諒 ^^'
      } else if (type === 3) {
        this.ratingInfo.reply_comment = '已請客服聯絡，希望能解決您的問題！歡迎再次訂購 ^^'
      }
    },
    reply () {
      if (!this.ratingInfo.reply_comment) {
        this.$notify({
          title: '提醒',
          text: '回覆內容未填！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.ratingInfo.is_replied) this.updateReplay()
      else this.createReplay()
    },
    updateReplay () {
      const self = this
      const url = '/rating/' + this.ratingInfo.rating_id + '/reply'
      const data = {
        comment: this.ratingInfo.reply_comment
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    createReplay () {
      const self = this
      const url = '/rating/' + this.ratingInfo.rating_id + '/reply'
      const data = {
        comment: this.ratingInfo.reply_comment
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getRatingList()
          self.ratingInfo.is_replied = 1
        }
      })
    },
    openModal (rating) {
      const self = this
      const url = '/rating/' + rating.rating_id + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.ratingInfo = response.data.info
        }
      })
    },
    brandName (brandId) {
      const brand = this.brandBrief.find(function (brand) {
        return brandId === brand.value
      })
      if (brand) return brand.label
      return ''
    },
    search (method) {
      if (method === 1 && this.menuTime.start.time && this.menuTime.end.time) {
        window.sessionStorage.removeItem('Nidin_orderTable_orderSn')
        window.sessionStorage.removeItem('Nidin_orderTable_shopper')
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount')
        this.getRatingList(1)
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method)
      } else if (method === 2 && this.orderSn) {
        window.sessionStorage.removeItem('Nidin_orderTable_shopper')
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount')
        window.sessionStorage.setItem('Nidin_orderTable_orderSn', this.orderSn)
        this.getRatingList(1)
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method)
      } else if (method === 3 && this.shopper) {
        window.sessionStorage.removeItem('Nidin_orderTable_subOrderAmount')
        window.sessionStorage.setItem('Nidin_orderTable_shopper', this.shopper)
        this.getRatingList(1)
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method)
      } else if (method === 4 && parseInt(this.subOrderAmount, 10)) {
        window.sessionStorage.removeItem('Nidin_orderTable_shopper')
        window.sessionStorage.setItem('Nidin_orderTable_subOrderAmount', this.subOrderAmount)
        this.getRatingList(1)
        window.sessionStorage.setItem('Nidin_orderTable_searchS', method)
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    payType (type) {
      if (type === 10) {
        return '線上支付'
      } else if (type === 50) {
        return '店家支付'
      }
    },
    labelColor (type) {
      if (type === 1) {
        return 'label-default'
      } else if (type === 707 || type === 701) {
        return 'label-success'
      } else if (type === 709) {
        return 'label-danger'
      } else if (type === 710) {
        return 'label-info'
      }
    },
    stateColor (state) {
      if (state === 11) {
        return 'label-default'
      } else if (state === 12) {
        return 'label-primary'
      } else if (state === 13) {
        return 'label-success'
      } else if (state === 21) {
        return 'label-danger'
      } else if (state === 22) {
        return 'label-danger'
      }
    },
    tradeType (type) {
      if (type === 1) {
        return '現金'
      } else if (type === 707) {
        return 'LINE PAY'
      } else if (type === 701) {
        return 'iPASS MONEY'
      } else if (type === 709) {
        return '信用卡(台新)'
      } else if (type === 710) {
        return '信用卡'
      }
    },
    payStateName (state) {
      if (state === 11) {
        return '未付款'
      } else if (state === 12) {
        return '付款中'
      } else if (state === 13) {
        return '已收款'
      } else if (state === 21) {
        return '退款中'
      } else if (state === 22) {
        return '已退款'
      }
    },
    orderStateColor (state) {
      switch (state) {
        case 140: // 已作廢
        case 120: // 被店家退訂
        case 121: // 被系統退訂
        case 122: // 已取消
        case 99: // 使用者取消訂單
          return 'label-danger'
        case 100: // 未接單
          return 'label-default'
        case 110: // 已接單
          return 'label-primary'
        case 130: // 已完成
          return 'label-success'
        default:
          return 'label-warning'
      }
    },
    orderState (state) {
      if (state === 0) {
        return '訂單尚未確認'
      } else if (state === 1) {
        return '訂單已送出，尚未付款'
      } else if (state === 2) {
        return '付款中'
      } else if (state === 3) {
        return '訂單已付款，尚未通知店家'
      } else if (state === 99) {
        return '客人取消'
      } else if (state === 100) {
        return '未接單'
      } else if (state === 110) {
        return '已接單'
      } else if (state === 120) {
        return '店家退訂'
      } else if (state === 121) {
        return '系統退訂'
      } else if (state === 122) {
        return '已取消'
      } else if (state === 130) {
        return '已完成'
      } else if (state === 140) {
        return '已作廢'
      }
    },
    shippingStateColor (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三方取消(分派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'text-danger'
        case 0: // 叫件開案
          return 'text-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確定叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'text-primary'
        case 140: // 司機已送達
          return 'text-success'
        default:
          return ''
      }
    },
    shippingStateColorBg  (state) {
      switch (state) {
        case 19: // 已拒絕報價
        case 59: // 自動叫件處理失敗
        case 900: // 門市取消叫件
        case 901: // 系統/門市取消
        case 910: // 第三方拒絕訂單
        case 920: // 第三方取消
        case 921: // 第三方取消(分派司機失敗)
        case 930: // 司機取件失敗
        case 940: // 司機配送失敗
          return 'bg-danger'
        case 0: // 叫件開案
          return 'bg-default'
        case 10: // 已報價
        case 50: // 自動叫件處理中
        case 100: // 門市已確定叫件
        case 110: // 未分派司機
        case 120: // 第三方已分派外送員
        case 130: // 司機已取貨,開始送貨
          return 'bg-primary'
        case 140: // 司機已送達
          return 'bg-success'
        default:
          return ''
      }
    },
    shippingState (state) {
      if (state === 0) {
        return '叫件開案'
      } else if (state === 10) {
        return '已報價'
      } else if (state === 19) {
        return '報價失敗'
      } else if (state === 50) {
        return '叫件中'
      } else if (state === 59) {
        return '叫件失敗'
      } else if (state === 100) {
        return '成立物流單'
      } else if (state === 110) {
        return '物流接單'
      } else if (state === 120) {
        return '已分派外送員'
      } else if (state === 130) {
        return '已取貨'
      } else if (state === 140) {
        return '已送達'
      } else if (state === 900 || state === 901 || state === 910 || state === 921 || state === 930 || state === 940) {
        return '門市取消叫件'
      } else if (state === 920) {
        return '媒合失敗'
      }
    },
    selectStyle (item) {
      var self = this
      this.$nextTick(function () {
        this.ratingList.forEach(function (item) {
          self.$set(item, 'active', false)
        })
        this.$set(item, 'active', true)
      })
    },
    outStyle (item) {
      this.$set(item, 'active', false)
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getRatingList()
    },
    getRatingList (page) {
      this.isLoading = true
      if (page) {
        this.tableIndex = page
        if (page === 1) this.pageGroup = 1
      }
      var self = this
      const data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = '/rating/list?page=' + this.tableIndex + '&size=' + this.count
      if (this.brandSelect.value && this.getRoleType === 99) url = url + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value) url = url + '&store_id=' + this.storeSelect.value
      if (this.starSelect) url = url + '&star=' + this.starSelect
      if (this.repliedSelect !== 99) url = url + '&is_replied=' + this.repliedSelect
      if (this.mainSelect !== 99) url = url + '&is_main=' + this.mainSelect
      if (parseInt(this.searchSelect, 10) === 1) {
        // use time search
        url = url + '&start_time=' + data.start_time + '&end_time=' + data.end_time
      }
      if (url) {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.ratingList = response.data.list
            self.total = response.data.list_total
            self.isLoading = false
          }
        })
      }
    },
    getBrandBrief () {
      var self = this
      self.brandBrief = [{label: '== 品牌 ==', value: 0}]
      var url = '/brand/listBrief?is_delete=0&is_opening=1&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            // is_visible = 0 為測試
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0 && (self.roleType === 10 || bList.length === 1)) self.brandSelect = obj
          }
          if (self.roleType === 30 || self.roleType === 99) self.getRatingList()
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      self.storeBrief = [{label: '== 門市 ==', value: 0}]
      var url = '/brand/' + brandId + '/storeListBrief?status=1,2&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) {
              if (self.getRoleType === '10' || self.getRoleType === 10) {
                self.storeSelect.label = obj.label
                self.storeSelect.value = obj.value
              }
              self.getRatingList(1)
            }
          }
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    checkMemberShow (status) {
      if (this.roleType === 30) {
        if (status === 130 || status === 140) return true
        else return false
      } else return true
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD HH:mm')
    }
  },
  created () {
    this.getBrandBrief()
    this.roleType = parseInt(this.getRoleType, 10)
  },
  mounted () {
    this.$refs.orderPaginate.tableIndex = this.tableIndex
    this.$refs.orderPaginate.pageGroup = this.pageGroup
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    'brandSelect.value' () {
      this.storeSelect = {value: 0, label: '== 門市 =='}
      if (this.$route.name === 'storeInfo') {
        this.storeSelect.value = this.$route.params.store_id
        this.getStoreBrief(this.brandSelect.value)
      } if (this.brandSelect.value !== 0 && this.brandSelect.value !== '0') {
        this.getStoreBrief(this.brandSelect.value)
      } else {
        this.getRatingList(1)
      }
    },
    'storeSelect.value' () {
      this.getRatingList(1)
    },
    repliedSelect () {
      this.getRatingList(1)
    },
    starSelect () {
      this.getRatingList(1)
    },
    mainSelect () {
      this.getRatingList(1)
    },
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('90', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    }
  }
}
</script>
<style lang="sass">
.shipping-state-label
  position: absolute
  width: max-content
  padding: 5px
  border-radius: 6px
  z-index: 30
  font-size: 12px
  font-weight: 600
  top: -30px
  left: -18px
.text-del
  text-decoration: line-through
.bg-pre-order
  background: #FBF4E6 !important
.active.btn-all, .active.btn-basic, .active.btn-gb
  opacity: 0.4
.p-10
 padding: 10px !important
.time-box
  max-width: 236px
  #start-box, #end-box
    width: auto
  #start-box input
    border-radius: 3px 0px 0px 0px !important
  #end-box input
    border-radius: 0px 0px 0px 3px !important
@media screen and (max-width: 768px)
  .time-box
    max-width: calc( 100vw - 20px)
@media screen and (max-width: 768px)
 .time-box .cov-vue-date .cov-datepicker
    width: calc(100vw - 90px)
</style>



// WEBPACK FOOTER //
// RatingTableTemp.vue?0b3fa1d4